import axios from 'axios';

const api = axios.create({
  baseURL: '/api',
  withCredentials: false,
});

let refreshPromise = null;

const refreshAccessToken = async () => {
  const refresh = localStorage.getItem('refresh');

  if (!refresh) {
    throw new Error('Refresh token is missing');
  }

  if (!refreshPromise) {
    refreshPromise = axios
      .post('/api/auth/refresh/', { refresh })
      .then((res) => {
        const access = res.data?.access;

        if (!access) {
          throw new Error('Refresh response has no access token');
        }

        localStorage.setItem('access', access);

        if (res.data?.refresh) {
          localStorage.setItem('refresh', res.data.refresh);
        }

        return access;
      })
      .finally(() => {
        refreshPromise = null;
      });
  }

  return refreshPromise;
};

const isPublicAuthRequest = (url = '') =>
  ['/auth/signup/', '/auth/signin/', '/auth/refresh/'].some((path) =>
    String(url).endsWith(path)
  );

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('access');

  if (token && !isPublicAuthRequest(config.url)) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const original = error.config;

    if (
      error?.response?.status !== 401 ||
      !original ||
      original._retry ||
      isPublicAuthRequest(original.url)
    ) {
      return Promise.reject(error);
    }

    const refresh = localStorage.getItem('refresh');

    if (!refresh) {
      return Promise.reject(error);
    }

    original._retry = true;

    try {
      const access = await refreshAccessToken();

      original.headers = original.headers || {};
      original.headers.Authorization = `Bearer ${access}`;

      return api(original);
    } catch (refreshError) {
      return Promise.reject(refreshError);
    }
  }
);

export default api;
